export default __webpack_public_path__ + "static/media/asesoramiento.d298b596.png";